<script lang="ts">
  import type { Api } from "../lib/api";
  import { ApiError } from "../lib/api";
  import Field from "../lib/ui/Field.svelte";
  import Button from "../lib/ui/Button.svelte";
  import Banner from "../lib/ui/Banner.svelte";
  import { Icon } from "@price-check/ui";
  import { Gem } from "lucide";

  let { api, onLogin }: { api: Api; onLogin: (token: string) => void } = $props();

  let email = $state("");
  let password = $state("");
  let busy = $state(false);
  let error = $state("");

  async function submit(e: Event) {
    e.preventDefault();
    error = "";
    busy = true;
    try {
      const r = await api.login(email.trim().toLowerCase(), password);
      onLogin(r.token);
    } catch (err) {
      error =
        err instanceof ApiError && err.status === 401
          ? "Invalid email or password."
          : "Could not reach the server. Try again.";
    } finally {
      busy = false;
    }
  }
</script>

<div
  class="min-h-screen flex flex-col items-center justify-center gap-3.5 p-6
    bg-[radial-gradient(1100px_520px_at_50%_-8%,color-mix(in_srgb,var(--color-brand)_10%,transparent),transparent_70%),var(--color-page)]"
>
  <form
    class="bg-surface border border-border rounded-lg w-full max-w-[384px] px-7.5 py-8 shadow-sm"
    onsubmit={submit}
  >
    <div
      class="grid place-items-center w-10.5 h-10.5 rounded-xl text-on-brand text-xl mb-4
        bg-[linear-gradient(135deg,var(--color-brand),var(--color-brand-strong))]
        shadow-md"
      aria-hidden="true"
    >
      <Icon icon={Gem} size={20} />
    </div>
    <h1 class="text-2xl font-extrabold m-0 mb-1.25">Pretaro portal</h1>
    <p class="text-muted text-sm m-0 mb-5.5">Sign in with your Price&nbsp;Check account.</p>

    <div class="flex flex-col gap-3.75 mb-5.5">
      <Field
        id="email"
        label="Email"
        type="email"
        name="username"
        autocomplete="username"
        bind:value={email}
      />
      <Field
        id="pw"
        label="Password"
        type="password"
        autocomplete="current-password"
        bind:value={password}
      />
    </div>

    <Button type="submit" full disabled={busy || !email || !password}>
      {busy ? "Signing in…" : "Sign in"}
    </Button>

    {#if error}<div class="mt-4"><Banner>{error}</Banner></div>{/if}
  </form>
  <p class="text-xs text-muted m-0">App users can download installers here.</p>
</div>
